import { Outlet } from 'react-router';

const CustomerSuccessLayout = () => <Outlet />;

export default CustomerSuccessLayout;
